angular.module('dnecom')
    .directive('validationNotNumber', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelController) {
                ngModelController.$validators.validationNotNumber = function (modelValue, viewValue) {
                    if (ngModelController.$isEmpty(modelValue)) {
                        return true;
                    }

                    return isNaN(viewValue);
                }
            }
        }
    });

